import { Button } from '@components/core-ui/form-elements/buttons/Button/';
import { OutlinedButton } from '@components/core-ui/form-elements/buttons/Button/variations/OutlinedButton';
import { ModalWrapper } from '@modals/core-ui/ModalWrapper';
import { ModalTitle } from '@modals/core-ui/ModalTitle';
import { TProps } from './types/TProps';

export const GenericConfirmationModal = ({ title, description, buttonText, onCancel, onSuccess }: TProps) => (
  <ModalWrapper width="400px">
    <ModalTitle>{title}</ModalTitle>
    <p className="m-0 text-center">{description}</p>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSuccess();
      }}
    >
      <div className="mx-auto flex justify-center w-[300px] gap-2.5">
        {onCancel ? (
          <OutlinedButton className="min-w-[100px]" type="button" onClick={onCancel}>
            Cancel
          </OutlinedButton>
        ) : null}
        <Button className="min-w-[100px]" type="submit">
          {buttonText}
        </Button>
      </div>
    </form>
  </ModalWrapper>
);
